// extracted by mini-css-extract-plugin
module.exports = {"bis146":"bis146","d16kq653":"d16kq653"};